import api from "@/api/viktor"
import { useConfigStore } from "@/stores/config"
import type { ScreeningWritingConversation } from "@/types/screening-writing"

const basePath = (pm_uuid: string, user_uuid: string) =>
  `/pm/${pm_uuid}/user/${user_uuid}/scan-writing`

/**
 * Absolute URL of the CONTINUE (PATCH) endpoint, consumed by the AG-UI HttpAgent.
 * Needs the full origin because the agent streams through the browser `fetch`,
 * not the axios instance.
 */
export function getScreeningWritingAgentUrl(
  pm_uuid: string,
  user_uuid: string
): string {
  const { urls } = useConfigStore()
  return `${urls.api}${basePath(pm_uuid, user_uuid)}`
}

export async function createScreeningWritingConversation(
  pm_uuid: string,
  user_uuid: string
): Promise<{ thread_id: string }> {
  const response = await api({
    method: "POST",
    url: basePath(pm_uuid, user_uuid),
  })
  return response
}

export async function getScreeningWritingConversation(
  pm_uuid: string,
  user_uuid: string
): Promise<ScreeningWritingConversation> {
  const response = await api({
    method: "GET",
    url: basePath(pm_uuid, user_uuid),
  })
  return response
}

export async function abortScreeningWritingConversation(
  pm_uuid: string,
  user_uuid: string
): Promise<void> {
  await api({
    method: "POST",
    url: `${basePath(pm_uuid, user_uuid)}/abort`,
  })
}
